import type { RosterType } from '@interfaces/chime';

export class AttendeeHandler {
  public printRoster(roster: RosterType) {
    Object.keys(roster).forEach((key) => {
      console.log(roster[key]);
    });
  }
}
